module.exports = __webpack_public_path__ + "media/images/audio-waves-55f962b278b03d80adea649e66d54a2d.svg";